export default __webpack_public_path__ + "static/media/22.18d69e13.webp";